import type { DefaultTranslationsObject, Language } from '../types.js'

export const isTranslations: DefaultTranslationsObject = {
  authentication: {
    account: 'Aðgangur',
    accountOfCurrentUser: 'Aðgangur notanda',
    accountVerified: 'Aðgangur staðfestur.',
    alreadyActivated: 'Þegar virkur',
    alreadyLoggedIn: 'Þegar innskráður',
    apiKey: 'API lykill',
    authenticated: 'Auðkenndur',
    backToLogin: 'Aftur á innskráningu',
    beginCreateFirstUser: 'Til að byrja, skráðu þinn fyrsta notanda.',
    changePassword: 'Breyta lykilorði',
    checkYourEmailForPasswordReset:
      'Ef netfangið er tengt reikningi muntu fá leiðbeiningar um að endurstilla lykilorðið þitt innan skamms. Vinsamlegast athugaðu ruslpóstmöppuna þína ef þú sérð ekki tölvupóstinn í pósthólfinu þínu.',
    confirmGeneration: 'Staðfestu sjálfvirka myndun',
    confirmPassword: 'Staðfestu lykilorð',
    createFirstUser: 'Skrá fyrsta notanda',
    emailNotValid: 'Netfangið er ekki gilt',
    emailOrUsername: 'Netfang eða notandanafn',
    emailSent: 'Tölvupóstur sendur',
    emailVerified: 'Netfang staðfest.',
    enableAPIKey: 'Virkja API lykil',
    failedToUnlock: 'Aflæsing tókst ekki',
    forceUnlock: 'Þvinga aflæsingu',
    forgotPassword: 'Gleymt lykilorð',
    forgotPasswordEmailInstructions:
      'Vinsamlega sláðu inn netfangið þitt. Þú munt fá tölvupóst með leiðbeiningum um hvernig á að endursetja lykilorð.',
    forgotPasswordQuestion: 'Gleymt lykilorð?',
    forgotPasswordUsernameInstructions:
      'Vinsamlegast sláðu inn notandanafnið þitt hér að neðan. Leiðbeiningar um hvernig á að endurstilla lykilorðið þitt verða sendar á netfangið sem tengt er notandanafninu þínu.',
    generate: 'Mynda sjálfvirkt',
    generateNewAPIKey: 'Sjálfvirkt mynda nýjan API lykil',
    generatingNewAPIKeyWillInvalidate:
      'Að mynda nýjan API lykil mun <1>óvirkja</1> fyrri lykil. Ertu viss um að halda áfram?',
    lockUntil: 'Læsa þar til',
    logBackIn: 'Innskrá aftur',
    loggedIn: 'Til að innskrá með öðrum notanda, þarftu að <0>útskrá</0> fyrst.',
    loggedInChangePassword:
      'Til að breyta lykilorði, farðu á <0>reikninginn</0> þinn og breyttu lykilorðinu þar.',
    loggedOutInactivity: 'Þú hefur verið útskráður vegna óvirkni.',
    loggedOutSuccessfully: 'Útskráning tókst.',
    loggingOut: 'Útskrái...',
    login: 'Innskráning',
    loginAttempts: 'Innskráningar tilraunir',
    loginUser: 'Innskrá notanda',
    loginWithAnotherUser:
      'Til að skrá sig inn með öðrum notanda ættir þú að <0>skrá þig út</0> fyrst.',
    logOut: 'Útskrá',
    logout: 'Útskrá',
    logoutSuccessful: 'Útskráning tókst.',
    logoutUser: 'Útskrá notanda',
    newAccountCreated:
      'Nýr reikningur hefur verið búinn til fyrir þig til að fá aðgang að <a href="{{serverURL}}">{{serverURL}}</a> Vinsamlegast smelltu á eftirfarandi hlekk eða límdu vefslóðina hér að neðan í vafrann þinn til að staðfesta netfangið þitt: <a href="{{verificationURL}}">{{verificationURL}}</a><br> Eftir að þú hefur staðfest netfangið þitt muntu geta skráð þig inn.',
    newAPIKeyGenerated: 'Nýr API lykill myndaður.',
    newPassword: 'Nýtt lykilorð',
    passed: 'Auðkenning tókst',
    passwordResetSuccessfully: 'Lykilorð endursett.',
    resetPassword: 'Endursetja lykilorð',
    resetPasswordExpiration: 'Endursetning lykilorðs rennur út',
    resetPasswordToken: 'Endursetja lykilorðs tóka',
    resetYourPassword: 'Endursetja lykilorð',
    stayLoggedIn: 'Haldast innskráður',
    successfullyRegisteredFirstUser: 'Skráning fyrsta notanda tókst.',
    successfullyUnlocked: 'Aflæsing tókst',
    tokenRefreshSuccessful: 'Endursetning tóka tókst.',
    unableToVerify: 'Staðfesting tókst ekki',
    username: 'Notandanafn',
    usernameNotValid: 'Notandanafnið sem þú skráðir er ekki gilt',
    verified: 'Staðfest',
    verifiedSuccessfully: 'Staðfest',
    verify: 'Staðfesta',
    verifyUser: 'Staðfesta notanda',
    verifyYourEmail: 'Staðfestu netfangið þitt',
    youAreInactive:
      'Þú hefur ekki verið virkur í smá stund og verður fljótlega skráður út sjálfkrafa til öryggis. Viltu halda innskráningu?',
    youAreReceivingResetPassword:
      'Þú færð þetta vegna þess að þú (eða einhver annar) hefur beðið um að endurstilla lykilorðið fyrir reikninginn þinn. Vinsamlegast smelltu á eftirfarandi hlekk eða límdu þetta í vafrann þinn til að ljúka ferlinu:',
    youDidNotRequestPassword:
      'Ef þú baðst ekki um þetta, vinsamlegast hunsaðu þennan tölvupóst og lykilorðið þitt verður óbreytt.',
  },
  error: {
    accountAlreadyActivated: 'Þessi aðgangur hefur þegar verið virkjaður.',
    autosaving: 'Villa kom upp við sjálfvirka vistun á færslu.',
    correctInvalidFields: 'Vinsamlega leiðréttu rangt skráða reiti.',
    deletingFile: 'Villa kom upp við að eyða skrá.',
    deletingTitle:
      'Villa kom upp við að eyða {{title}}. Vinsamlegast athugaðu tenginguna þína og reyndu aftur.',
    documentNotFound:
      'Færsla með auðkenni {{id}} fannst ekki. Því kann að hafa verið eytt eða aldrei til, eða þú gætir ekki haft aðgang að því.',
    emailOrPasswordIncorrect: 'Netfangið eða lykilorðið sem gefið var upp er rangt.',
    followingFieldsInvalid_one: 'Eftirfarandi svæði er ógilt:',
    followingFieldsInvalid_other: 'Eftirfarandi svæði eru ógild:',
    incorrectCollection: 'Rangt safn',
    insufficientClipboardPermissions:
      'Aðgangur að klemmuspjaldi hafnað. Vinsamlegast athugaðu klemmuspjaldsheimildir þínar.',
    invalidClipboardData: 'Ógild klemmuspjaldsgögn.',
    invalidFileType: 'Ógild skráartegund',
    invalidFileTypeValue: 'Ógild skráartegund: {{value}}',
    invalidRequestArgs: 'Ógild viðföng send í beiðni: {{args}}',
    loadingDocument: 'Vandamál kom upp við að sækja færslu með ID: {{id}}.',
    localesNotSaved_one: 'Ekki tókst að vista eftirfarandi staðfærslu:',
    localesNotSaved_other: 'Ekki tókst að vista eftirfarandi staðfærslur:',
    logoutFailed: 'Útskráning mistókst.',
    missingEmail: 'Vantar netfang.',
    missingIDOfDocument: 'Vantar auðkenni skjals til að uppfæra.',
    missingIDOfVersion: 'Vantar auðkenni útgáfu.',
    missingRequiredData: 'Vantar nauðsynleg gögn.',
    noFilesUploaded: 'Engum skrám var hlaðið upp.',
    noMatchedField: 'Ekkert samsvarandi svæði fannst fyrir "{{label}}"',
    notAllowedToAccessPage: 'Þér er ekki heimilt að fara á þessa síðu.',
    notAllowedToPerformAction: 'Þér er ekki heimilt að framkvæma þessa aðgerð.',
    notFound: 'Umbeðnar upplýsingar fundust ekki.',
    noUser: 'Enginn notandi',
    previewing: 'Vandamál kom upp við að forskoða þessa færslu.',
    problemUploadingFile: 'Vandamál kom upp við að hlaða upp skránni.',
    restoringTitle:
      'Villa kom upp við að endurheimta {{title}}. Vinsamlegast athugaðu tenginguna þína og reyndu aftur.',
    tokenInvalidOrExpired: 'Token er annað hvort ógilt eða útrunnið.',
    tokenNotProvided: 'Token var gefið upp.',
    unableToCopy: 'Ekki hægt að afrita.',
    unableToDeleteCount: 'Ekki hægt að eyða {{count}} af {{total}} {{label}}.',
    unableToReindexCollection: 'Villa við að endurskrá safn {{collection}}. Aðgerð hætt við.',
    unableToUpdateCount: 'Ekki hægt að uppfæra {{count}} af {{total}} {{label}}.',
    unauthorized: 'Óheimilt, þú verður að vera innskráður til að gera þessa beiðni.',
    unauthorizedAdmin: 'Óheimilt, þessi notandi hefur ekki aðgang að stjórnborðinu.',
    unknown: 'Óþekkt villa hefur komið upp.',
    unPublishingDocument: 'Vandamál kom upp við að taka færsluna úr birtingu.',
    unspecific: 'Villa hefur komið upp.',
    unverifiedEmail: 'Vinsamlegast staðfestu netfangið þitt áður en þú skráir þig inn.',
    userEmailAlreadyRegistered: 'Notandi með þetta netfang er þegar skráður.',
    userLocked: 'Þessi notandi er læstur vegna of margra misheppnaðra innskráningartilrauna.',
    usernameAlreadyRegistered: 'Notandi með þetta notandanafn er þegar skráður.',
    usernameOrPasswordIncorrect: 'Notandanafnið eða lykilorðið sem gefið var upp er rangt.',
    valueMustBeUnique: 'Gildi verður að vera einstakt',
    verificationTokenInvalid: 'Staðfestingartoken er ógilt.',
  },
  fields: {
    addLabel: 'Bæta við {{label}}',
    addLink: 'Bæta við hlekk',
    addNew: 'Bæta við nýju',
    addNewLabel: 'Bæta við {{label}}',
    addRelationship: 'Bæta við tengingu',
    addUpload: 'Bæta við skrá',
    block: 'blokk',
    blocks: 'blokkir',
    blockType: 'Blokkartegund',
    chooseBetweenCustomTextOrDocument:
      'Veldu á milli að slá inn sérsniðna vefslóð eða tengja við aðra færslu.',
    chooseDocumentToLink: 'Veldu færslu til að tengja við',
    chooseFromExisting: 'Velja af skráðum',
    chooseLabel: 'Velja {{label}}',
    collapseAll: 'Fella allt saman',
    customURL: 'Sérsniðin vefslóð',
    editLabelData: 'Breyta {{label}} gögnum',
    editLink: 'Breyta hlekk',
    editRelationship: 'Breyta tengingu',
    enterURL: 'Sláðu inn vefslóð',
    internalLink: 'Innri hlekkur',
    itemsAndMore: '{{items}} og {{count}} fleiri',
    labelRelationship: '{{label}} tenging',
    latitude: 'Breiddargráða',
    linkedTo: 'Tengt við <0>{{label}}</0>',
    linkType: 'Tegund hlekks',
    longitude: 'Lengdargráða',
    newLabel: 'Nýtt {{label}}',
    openInNewTab: 'Opna í nýjum flipa',
    passwordsDoNotMatch: 'Lykilorð eru ekki eins.',
    relatedDocument: 'Tengdar færslur',
    relationTo: 'Tenging við',
    removeRelationship: 'Fjarlægja tengingu',
    removeUpload: 'Fjarlægja skrá',
    saveChanges: 'Vista breytingar',
    searchForBlock: 'Leita að blokk',
    searchForLanguage: 'Leitaðu að tungumáli',
    selectExistingLabel: 'Veldu núverandi {{label}}',
    selectFieldsToEdit: 'Veldu reit til að breyta',
    showAll: 'Sýna allt',
    swapRelationship: 'Skipta út tengingu',
    swapUpload: 'Skipta út skrá',
    textToDisplay: 'Texti til að birta',
    toggleBlock: 'Fletta blokk',
    uploadNewLabel: 'Hlaða upp nýju {{label}}',
  },
  folder: {
    browseByFolder: 'Flakka eftir möppu',
    byFolder: 'Eftir möppu',
    deleteFolder: 'Eyða möppu',
    folderName: 'Möppunafn',
    folders: 'Möppurnar',
    folderTypeDescription: 'Veldu hvaða tegund safnskjala ætti að vera leyfð í þessari möppu.',
    itemHasBeenMoved: '{{title}} hefur verið færð í {{folderName}}',
    itemHasBeenMovedToRoot: '{{title}} hefur verið færð í rótarmöppuna',
    itemsMovedToFolder: '{{title}} færð í {{folderName}}',
    itemsMovedToRoot: '{{title}} færð í rótarmöppuna',
    moveFolder: 'Færa möppu',
    moveItemsToFolderConfirmation:
      'Þú ert að fara að færa <1>{{count}} {{label}}</1> í <2>{{toFolder}}</2>. Ertu viss?',
    moveItemsToRootConfirmation:
      'Þú ert að fara að færa <1>{{count}} {{label}}</1> í rótarmöppuna. Ertu viss?',
    moveItemToFolderConfirmation:
      'Þú ert að fara að færa <1>{{title}}</1> í <2>{{toFolder}}</2>. Ertu viss?',
    moveItemToRootConfirmation:
      'Þú ert að fara að færa <1>{{title}}</1> í rótarmöppuna. Ertu viss?',
    movingFromFolder: 'Færi {{title}} úr {{fromFolder}}',
    newFolder: 'Ný mappa',
    noFolder: 'Engin mappa',
    renameFolder: 'Endurnefna möppu',
    searchByNameInFolder: 'Leita eftir nafni í {{folderName}}',
    selectFolderForItem: 'Veldu möppu fyrir {{title}}',
  },
  general: {
    name: 'Nafn',
    aboutToDelete: 'Þú ert að fara að eyða {{label}} <1>{{title}}</1>. Ertu viss?',
    aboutToDeleteCount_many: 'Þú ert að fara að eyða {{count}} {{label}}',
    aboutToDeleteCount_one: 'Þú ert að fara að eyða {{count}} {{label}}',
    aboutToDeleteCount_other: 'Þú ert að fara að eyða {{count}} {{label}}',
    aboutToPermanentlyDelete:
      'Þú ert að fara að eyða {{label}} <1>{{title}}</1> varanlega. Ertu viss?',
    aboutToPermanentlyDeleteTrash:
      'Þú ert að fara að eyða <0>{{count}}</0> <1>{{label}}</1> varanlega úr ruslinu. Ertu viss?',
    aboutToRestore: 'Þú ert að fara að endurheimta {{label}} <1>{{title}}</1>. Ertu viss?',
    aboutToRestoreAsDraft:
      'Þú ert að fara að endurheimta {{label}} <1>{{title}}</1> sem drög. Ertu viss?',
    aboutToRestoreAsDraftCount: 'Þú ert að fara að endurheimta {{count}} {{label}} sem drög',
    aboutToRestoreCount: 'Þú ert að fara að endurheimta {{count}} {{label}}',
    aboutToTrash: 'Þú ert að fara að færa {{label}} <1>{{title}}</1> í ruslið. Ertu viss?',
    aboutToTrashCount: 'Þú ert að fara að færa {{count}} {{label}} í ruslið',
    addBelow: 'Bæta við fyrir neðan',
    addFilter: 'Bæta við síu',
    adminTheme: 'Stjórnborðs þema',
    all: 'Allt',
    allCollections: 'Öll söfn',
    allLocales: 'Allar staðfærslur',
    and: 'Og',
    anotherUser: 'Annar notandi',
    anotherUserTakenOver: 'Annar notandi hefur tekið yfir skráningu þessarar færslu.',
    applyChanges: 'Virkja breytingar',
    ascending: 'Hækkandi',
    automatic: 'Sjálfvirkt',
    backToDashboard: 'Aftur í stjórnborð',
    cancel: 'Hætta við',
    changesNotSaved:
      'Breytingarnar þínar hafa ekki verið vistaðar. Ef þú ferð núna muntu missa breytingarnar þínar.',
    clear: 'Hreinsa',
    clearAll: 'Hreinsa allt',
    close: 'Loka',
    collapse: 'Fella saman',
    collections: 'Söfn',
    columns: 'Dálkar',
    columnToSort: 'Dálkur til að raða',
    confirm: 'Staðfesta',
    confirmCopy: 'Staðfesta afritun',
    confirmDeletion: 'Staðfesta eyðingu',
    confirmDuplication: 'Staðfesta tvöföldun',
    confirmMove: 'Staðfesta tilfærslu',
    confirmReindex: 'Endursetja leitargrunn fyrir allar {{collections}}?',
    confirmReindexAll: 'Endursetja leitargrunn fyrir öll söfn?',
    confirmReindexDescription:
      'Þetta mun eyða núverandi leitargrunn og endursetja leitargrunn fyrir allar færslur í {{collections}}.',
    confirmReindexDescriptionAll:
      'Þetta mun eyða núverandi leitargrunn og endursetja leitargrunn fyrir færslur í öllum söfnum.',
    confirmRestoration: 'Staðfesta endurheimtu',
    copied: 'Afritað',
    copy: 'Afrita',
    copyField: 'Afrita svæði',
    copying: 'Afrita',
    copyRow: 'Afrita röð',
    copyWarning: 'Þú munt yfirskrifa {{to}} með {{from}} fyrir {{label}} {{title}}. Ertu viss?',
    create: 'Nýskrá',
    created: 'Nýskráð',
    createdAt: 'Nýskráð',
    createNew: 'Nýskrá',
    createNewLabel: 'Nýskrá: {{label}}',
    creating: 'Nýskrái',
    creatingNewLabel: 'Nýskrái {{label}}',
    currentlyEditing:
      'er að vinna í þessari færslu. Ef þú tekur yfir, mun viðkomandi ekki geta haldið áfram, og gæti glatað óvistuðum breytingum.',
    custom: 'Sérsniðið',
    dark: 'Dökkt',
    dashboard: 'Stjórnborð',
    delete: 'Eyða',
    deleted: 'Eytt',
    deletedAt: 'Eytt',
    deletedCountSuccessfully: 'Eyddi {{count}} {{label}}.',
    deletedSuccessfully: 'Eyðing tókst.',
    deleteLabel: 'Eyða {{label}}',
    deletePermanently: 'Sleppa rusli og eyða varanlega',
    deleting: 'Eyði...',
    depth: 'Dýpt',
    descending: 'Lækkandi',
    deselectAllRows: 'Afvelja allar raðir',
    document: 'Færsla',
    documentIsTrashed: 'Þetta {{label}} er í ruslinu og er skrifvarið.',
    documentLocked: 'Færsla læst',
    documents: 'Færslur',
    duplicate: 'Tvöfalda',
    duplicateWithoutSaving: 'Tvöfalda án þess að vista breytingar',
    edit: 'Breyta',
    editAll: 'Breyta öllu',
    editedSince: 'Breytt síðan',
    editing: 'Breyti',
    editingLabel_many: 'Breyti {{count}} {{label}}',
    editingLabel_one: 'Breyti {{count}} {{label}}',
    editingLabel_other: 'Breyti {{count}} {{label}}',
    editingTakenOver: 'Breyting yfirtekin',
    editLabel: 'Breyta {{label}}',
    email: 'Tölvupóstur',
    emailAddress: 'Netfang',
    emptyTrash: 'Tæma rusl',
    emptyTrashLabel: 'Tæma {{label}} rusl',
    enterAValue: 'Sláðu inn gildi',
    error: 'Villa',
    errors: 'Villur',
    exitLivePreview: 'Fara úr beinni forskoðun',
    export: 'Flytja út',
    fallbackToDefaultLocale: 'Nota sjálfgefna staðfærslu',
    false: 'Ósatt',
    filter: 'Sía',
    filters: 'Síur',
    filterWhere: 'Sía {{label}} þar sem',
    globals: 'Einstakir hlutir',
    goBack: 'Til baka',
    groupByLabel: 'Flokka eftir {{label}}',
    import: 'Flytja inn',
    isEditing: 'er að breyta',
    item: 'hlutur',
    items: 'hlutir',
    language: 'Tungumál',
    lastModified: 'Síðast breytt',
    leaveAnyway: 'Fara samt',
    leaveWithoutSaving: 'Fara án þess að vista',
    light: 'Ljóst',
    livePreview: 'Bein forskoðun',
    loading: 'Hleð',
    locale: 'Staðfærsla',
    locales: 'Staðfærslur',
    menu: 'Valmynd',
    moreOptions: 'Fleiri valkostir',
    move: 'Færa',
    moveConfirm: 'Þú ert að fara að færa {{count}} {{label}} í <1>{{destination}}</1>. Ertu viss?',
    moveCount: 'Færa {{count}} {{label}}',
    moveDown: 'Færa niður',
    moveUp: 'Færa upp',
    moving: 'Færi',
    movingCount: 'Færi {{count}} {{label}}',
    newLabel: 'Nýtt {{label}}',
    newPassword: 'Nýtt lykilorð',
    next: 'Næsta',
    no: 'Nei',
    noDateSelected: 'Engin dagsetning valin',
    noFiltersSet: 'Engar síur virkar',
    noLabel: '<Ekkert {{label}}>',
    none: 'Ekkert',
    noOptions: 'Engir valkostir',
    noResults:
      'Engar {{label}} fundust. Annað hvort er engin {{label}} til eða ekkert passar við síu sem þú hefur valið fyrir ofan.',
    notFound: 'Fannst ekki',
    nothingFound: 'Ekkert fannst',
    noTrashResults: 'Ekkert {{label}} í rusli.',
    noUpcomingEventsScheduled: 'Engir komandi viðburðir áætlaðir.',
    noValue: 'Ekkert gildi',
    of: 'af',
    only: 'Aðeins',
    open: 'Opna',
    or: 'Eða',
    order: 'Röð',
    overwriteExistingData: 'Yfirskrifa skráð gögn í reit',
    pageNotFound: 'Síða fannst ekki',
    password: 'Lykilorð',
    pasteField: 'Líma svæði',
    pasteRow: 'Líma röð',
    payloadSettings: 'Payload stillingar',
    permanentlyDelete: 'Eyða varanlega',
    permanentlyDeletedCountSuccessfully: 'Eyddi {{count}} {{label}} varanlega.',
    perPage: 'Á síðu: {{limit}}',
    previous: 'Fyrri',
    reindex: 'Endursetja leitargrunn',
    reindexingAll: 'Endursetja leitargrunn fyrir allar {{collections}}.',
    remove: 'Fjarlægja',
    rename: 'Endurnefna',
    reset: 'Endurstilla',
    resetPreferences: 'Endurstilla þínar stillingar',
    resetPreferencesDescription:
      'Þetta mun endurstilla allar stillingarnar þínar í sjálfgefnar stillingar.',
    resettingPreferences: 'Endurstilli þínar stillingar.',
    restore: 'Endurheimta',
    restoreAsPublished: 'Endurheimta sem útgefna útgáfu',
    restoredCountSuccessfully: 'Endurheimti {{count}} {{label}}.',
    restoring: 'Endurheimti...',
    row: 'Röð',
    rows: 'Raðir',
    save: 'Vista',
    saving: 'Vista...',
    schedulePublishFor: 'Áætla útgáfu fyrir {{title}}',
    searchBy: 'Leita eftir {{label}}',
    select: 'Velja',
    selectAll: 'Velja allar {{count}} {{label}}',
    selectAllRows: 'Velja allar raðir',
    selectedCount: '{{count}} {{label}} valið',
    selectLabel: 'Velja {{label}}',
    selectValue: 'Veldu gildi',
    showAllLabel: 'Sýna allar {{label}}',
    sorryNotFound: 'Því miður, það er ekkert sem samsvarar beiðninni þinni.',
    sort: 'Raða',
    sortByLabelDirection: 'Raða eftir {{label}} {{direction}}',
    stayOnThisPage: 'Áfram á þessari síðu',
    submissionSuccessful: 'Sending tókst.',
    submit: 'Senda',
    submitting: 'Sendi...',
    success: 'Tókst',
    successfullyCreated: '{{label}} var nýskráð.',
    successfullyDuplicated: '{{label}} tvöfaldað.',
    successfullyReindexed:
      'Tókst að endurvísa {{count}} af {{total}} skjölum úr {{collections}} og {{skips}} drög voru sleppt.',
    takeOver: 'Taka yfir',
    thisLanguage: 'Íslenska',
    time: 'Tími',
    timezone: 'Tímabelti',
    titleDeleted: '{{label}} "{{title}}" var eytt.',
    titleRestored: '{{label}} "{{title}}" endurheimt.',
    titleTrashed: '{{label}} "{{title}}" fært í rusl.',
    trash: 'Rusl',
    trashedCountSuccessfully: '{{count}} {{label}} færð í rusl.',
    true: 'Satt',
    unauthorized: 'Óheimilt',
    unsavedChanges:
      'Þú ert með óvistaðar breytingar. Vistaðu eða hættu við áður en þú heldur áfram.',
    unsavedChangesDuplicate: 'Þú ert með óvistaðar breytingar. Viltu halda áfram við að tvöfalda?',
    untitled: 'Ónefnt',
    upcomingEvents: 'Komandi viðburðir',
    updatedAt: 'Uppfært',
    updatedCountSuccessfully: 'Uppfærsla {{count}} {{label}} tókst.',
    updatedLabelSuccessfully: 'Uppfærði {{label}} með góðum árangri.',
    updatedSuccessfully: 'Uppfærsla tókst.',
    updateForEveryone: 'Uppfæra fyrir alla',
    updating: 'Uppfæri',
    uploading: 'Hleð upp',
    uploadingBulk: 'Hleð upp {{current}} af {{total}}',
    user: 'Notandi',
    username: 'Notandanafn',
    users: 'Notendur',
    value: 'Gildi',
    viewing: 'Skoða',
    viewReadOnly: 'Skoða sem skrifvarið',
    welcome: 'Velkomin',
    yes: 'Já',
  },
  localization: {
    cannotCopySameLocale: 'Ekki hægt að afrita í sömu staðfærslu',
    copyFrom: 'Afrita frá',
    copyFromTo: 'Afrita frá {{from}} til {{to}}',
    copyTo: 'Afrita til',
    copyToLocale: 'Afrita í staðfærslu',
    localeToPublish: 'Staðfærsla til að gefa út',
    selectedLocales: 'Valdar svæði',
    selectLocaleToCopy: 'Veldu staðfærslu til að afrita',
    selectLocaleToDuplicate: 'Veldu staðföng til að afrita',
  },
  operators: {
    contains: 'inniheldur',
    equals: 'jafngildir',
    exists: 'er til',
    intersects: 'skarast',
    isGreaterThan: 'er stærra en',
    isGreaterThanOrEqualTo: 'er stærra eða jafnt og',
    isIn: 'er inni í',
    isLessThan: 'er minna en',
    isLessThanOrEqualTo: 'er minna en eða jafnt og',
    isLike: 'er eins og',
    isNotEqualTo: 'er ekki jafnt og',
    isNotIn: 'er ekki í',
    isNotLike: 'er ekki eins og',
    near: 'nálægt',
    within: 'innan',
  },
  upload: {
    addFile: 'Bæta við skrá',
    addFiles: 'Bæta við skrám',
    bulkUpload: 'Magn upphal',
    crop: 'Skera',
    cropToolDescription:
      'Dragðu horn valda svæðisins, teiknaðu nýtt svæði eða stilltu gildin hér að neðan.',
    download: 'Sækja',
    dragAndDrop: 'Dragðu og slepptu skrá',
    dragAndDropHere: 'eða dragðu og slepptu skrá hér',
    editImage: 'Breyta mynd',
    fileName: 'Skráarnafn',
    fileSize: 'Skráarstærð',
    filesToUpload: 'Skrár til að hlaða upp',
    fileToUpload: 'Skrá til að hlaða upp',
    focalPoint: 'Brennipunktur',
    focalPointDescription:
      'Dragðu brennipunktinn beint á forskoðunina eða stilltu gildin hér að neðan.',
    height: 'Hæð',
    lessInfo: 'Minni upplýsingar',
    moreInfo: 'Fleiri upplýsingar',
    noFile: 'Engin skrá',
    pasteURL: 'Líma vefslóð',
    previewSizes: 'Forskoðunarstærðir',
    selectCollectionToBrowse: 'Veldu safn til að skoða',
    selectFile: 'Veldu skrá',
    setCropArea: 'Stilla klippingarsvæði',
    setFocalPoint: 'Stilla brennipunkt',
    sizes: 'Stærðir',
    sizesFor: 'Stærðir fyrir {{label}}',
    width: 'Breidd',
  },
  validation: {
    emailAddress: 'Vinsamlegast settu inn gilt netfang.',
    enterNumber: 'Vinsamlegast settu inn gilda tölu.',
    fieldHasNo: 'Þetta svæði hefur ekkert {{label}}',
    greaterThanMax: '{{value}} er stærra en hámarks leyfða {{label}} sem er {{max}}.',
    invalidBlock: 'Blokkið "{{block}}" er ekki leyft.',
    invalidBlocks: 'Þessi reitur inniheldur blokkir sem eru ekki lengur leyfðar: {{blocks}}.',
    invalidInput: 'Þetta svæði hefur ógilt inntak.',
    invalidSelection: 'Þetta svæði hefur ógilt val.',
    invalidSelections: 'Þetta svæði hefur eftirfarandi ógild völ:',
    latitudeOutOfBounds: 'Breiddargráða verður að vera á bilinu -90 og 90.',
    lessThanMin: '{{value}} er minna en lágmarks leyfða {{label}} sem er {{min}}.',
    limitReached: 'Mörkum náð, aðeins er hægt að bæta við {{max}} hlutum.',
    longerThanMin:
      'Þetta gildi verður að vera lengra en lágmarkslengdin sem er {{minLength}} stafir.',
    longitudeOutOfBounds: 'Lengdargráða verður að vera á bilinu -180 og 180.',
    notValidDate: '"{{value}}" er ekki gild dagsetning.',
    required: 'Þetta svæði er nauðsynlegt.',
    requiresAtLeast: 'Þetta svæði krefst að minnsta kosti {{count}} {{label}}.',
    requiresNoMoreThan: 'Þetta svæði krefst ekki meira en {{count}} {{label}}.',
    requiresTwoNumbers: 'Þetta svæði krefst tveggja talna.',
    shorterThanMax:
      'Þetta gildi verður að vera styttra en hámarkslengdin sem er {{maxLength}} stafir.',
    timezoneRequired: 'Tímabelti er nauðsynlegt.',
    trueOrFalse: 'Þetta svæði getur aðeins verið jafnt og satt eða ósatt.',
    username:
      'Vinsamlegast settu inn gilt notandanafn. Getur innihaldið bókstafi, tölur, bandstrik, punkta og undirstrik.',
    validUploadID: 'Þetta svæði er ekki gilt skráarupphleðslauðkenni.',
  },
  version: {
    type: 'Tegund',
    aboutToPublishSelection: 'Þú ert að fara að gefa út allar valdar {{label}}. Ertu viss?',
    aboutToRestore: 'Þú munt endurheimta {{label}} í þá stöðu sem það var þann {{versionDate}}.',
    aboutToRestoreGlobal:
      'Þú munt endurheimta {{label}} í þá stöðu sem það var í þann {{versionDate}}.',
    aboutToRevertToPublished:
      'Þú munt endursetja breytingar á þessari færslu í útgefna stöðu. Ertu viss?',
    aboutToUnpublish: 'Þú munt taka þessa færslu úr birtingu. Ertu viss?',
    aboutToUnpublishSelection: 'Þú munt taka úr birtingu allar valdar {{label}}. Ertu viss?',
    autosave: 'Sjálfvirk vistun',
    autosavedSuccessfully: 'Sjálfvirk vistun tókst.',
    autosavedVersion: 'Sjálfvirk vistuð útgáfa',
    changed: 'Breytt',
    changedFieldsCount_one: '{{count}} breytt svæði',
    changedFieldsCount_other: '{{count}} breytt svæði',
    compareVersion: 'Bera útgáfu saman við:',
    compareVersions: 'Bera útgáfur saman',
    comparingAgainst: 'Ber saman við',
    confirmPublish: 'Staðfesta útgáfu',
    confirmRevertToSaved: 'Staðfesta að snúa til baka í vistað',
    confirmUnpublish: 'Staðfesta afbirtingu',
    confirmVersionRestoration: 'Staðfesta endurheimtu útgáfu',
    currentDocumentStatus: 'Núverandi {{docStatus}} færslu',
    currentDraft: 'Núverandi drög',
    currentlyPublished: 'Nú útgefið',
    currentlyViewing: 'Skoða núna',
    currentPublishedVersion: 'Núverandi útgefin útgáfa',
    draft: 'Drög',
    draftHasPublishedVersion: 'Drög (hafa birt útgáfu)',
    draftSavedSuccessfully: 'Drög vistuð með góðum árangri.',
    lastSavedAgo: 'Síðast vistað {{distance}} síðan',
    modifiedOnly: 'Aðeins breytt',
    moreVersions: 'Fleiri útgáfur...',
    noFurtherVersionsFound: 'Engar fleiri útgáfur fundust',
    noLabelGroup: 'Ónefnd hópur',
    noRowsFound: 'Ekkert {{label}} fannst',
    noRowsSelected: 'Ekkert {{label}} valið',
    preview: 'Forskoðun',
    previouslyDraft: 'Áður drög',
    previouslyPublished: 'Áður útgefið',
    previousVersion: 'Fyrri útgáfa',
    problemRestoringVersion: 'Vandamál kom upp við að endurheimta þessa útgáfu',
    publish: 'Gefa út',
    publishAllLocales: 'Gefa út allar staðfærslur',
    publishChanges: 'Gefa út breytingar',
    published: 'Útgefið',
    publishIn: 'Gefa út í {{locale}}',
    publishing: 'Gef út',
    restoreAsDraft: 'Endurheimta sem drög',
    restoredSuccessfully: 'Endurheimtur með góðum árangri.',
    restoreThisVersion: 'Endurheimta þessa útgáfu',
    restoring: 'Endurheimti...',
    reverting: 'Sný til baka...',
    revertToPublished: 'Snúa til baka í útgefið',
    saveDraft: 'Vista drög',
    scheduledSuccessfully: 'Áætlað.',
    schedulePublish: 'Áætla útgáfu',
    selectLocales: 'Veldu staðfærslur til að birta',
    selectVersionToCompare: 'Veldu útgáfu til að bera saman',
    showingVersionsFor: 'Sýni útgáfur fyrir:',
    showLocales: 'Sýna staðfærslur:',
    specificVersion: 'Tiltekin útgáfa',
    status: 'Staða',
    unpublish: 'Taka úr birtingu',
    unpublishing: 'Tek úr birtingu...',
    version: 'Útgáfa',
    versionAgo: '{{distance}} síðan',
    versionCount_many: '{{count}} útgáfur fundust',
    versionCount_none: 'Engar útgáfur fundust',
    versionCount_one: '{{count}} útgáfa fannst',
    versionCount_other: '{{count}} útgáfur fundust',
    versionID: 'Útgáfuauðkenni',
    versions: 'Útgáfur',
    viewingVersion: 'Skoða útgáfu fyrir {{entityLabel}} {{documentTitle}}',
    viewingVersionGlobal: 'Skoða útgáfu fyrir {{entityLabel}}',
    viewingVersions: 'Skoða útgáfur fyrir {{entityLabel}} {{documentTitle}}',
    viewingVersionsGlobal: 'Skoða útgáfur fyrir {{entityLabel}}',
  },
}

export const is: Language = {
  dateFNSKey: 'is',
  translations: isTranslations,
}
